import { StoreSnapshotSchema } from "@pixelpuf/schemas/store";
import { store } from "./index.ts";

/**
 * Dev-only post-update validator. Subscribes to the store and runs
 * `StoreSnapshotSchema.safeParse` after each event. Mirrors the gate that the
 * pre-migration zustand store ran at apps/pixelpuf/src/store.ts:217–221. Logs
 * issues to the console without affecting runtime — surfaces drift early
 * (e.g. frameIds.length !== frames.length, stateFrames keys missing from machine).
 *
 * Call this once at app boot (from main.tsx) AFTER any code that imports the
 * store has had a chance to run, so the first parse sees the rehydrated context.
 */
const IS_DEV: boolean =
  ((env: unknown): boolean => typeof env === "object" && env !== null && "DEV" in env && env.DEV === true)(
    import.meta.env,
  );

export function installStoreInvariantGate(): () => void {
  if (!IS_DEV) return () => undefined;
  const sub = store.subscribe((snapshot) => {
    const r = StoreSnapshotSchema.safeParse(snapshot.context);
    if (!r.success) console.warn("[store] invariant broken:", r.error.issues);
  });
  return () => {
    sub.unsubscribe();
  };
}
